import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { connect } from 'redaction'
import { injectIntl } from 'sb-react-intl'
import { compose } from 'common/helpers'

import DropMenu from 'layouts/InsideLayout/Header/HeaderNavDropMenu/HeaderNavDropMenu'
import Item from 'layouts/InsideLayout/Header/HeaderNavItem/HeaderNavItem'
import ItemTitle from 'layouts/InsideLayout/Header/HeaderNavItemTitle/HeaderNavItemTitle'

import s from './HeaderNav.scss'


const HeaderNav = ({ pathname, className, items, uppercase, intl }) => (
  <ul className={cx(s.nav, className)} role="menu">
    {
      items.map(({ className, subNav, id, brand, withLightningIcon, dataTestId, ...item }, index) => {
        const navItemClassName = cx(s.navItem, className, {
          [s.brand]: brand,
          [s.active]: (item.to || item.toOLD) === pathname,
        })

        return (
          <Item
            key={index}
            className={navItemClassName}
            id={id}
          >
            {
              subNav ? (
                <DropMenu items={subNav} dataTestId={dataTestId}>
                  <ItemTitle {...item} uppercase={uppercase} />
                </DropMenu>
              ) : (
                <ItemTitle
                  {...item}
                  uppercase={uppercase}
                  withLightningIcon={withLightningIcon}
                  dataTestId={dataTestId}
                />
              )
            }
          </Item>
        )
      })
    }
  </ul>
)

HeaderNav.propTypes = {
  pathname: PropTypes.string, // @connect
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  uppercase: PropTypes.bool,
}


export default compose(
  connect({
    pathname: 'routing.location.pathname',
  }),
  injectIntl
)(HeaderNav)
